import { useCallback } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { showWarning } from "src/utils/toast/toastUtil";
import { validateItemAccount, isDuplicateChildItemcd, restoreOriginalValues } from "../Util_KSK2120_R01";
import { KSK2120_R01Dto } from "../Dto_KSK2120_R01";
import { getBomChildItemList } from "src/apis/bomApi";
import { getAfeederCodeList, getBfeederCodeList, getCfeederCodeList } from "src/apis/commonCodeApi";
import { getLotSearchList } from "src/apis/lotApi";

export function useKSK2120_R01CellChange({
	KSK2120_R01List,
	updateKSK2120_R01List,
	originalKSK2120_R01List,
	settingCodeSearchModalProps,
	gridRef
}: any) {
	// 자품목코드 자동 검색 함수
	const handleLotNoSearch = useCallback(
		async (lotNo: string, rowData: KSK2120_R01Dto, oldValue?: string) => {
			if (!lotNo || !lotNo.trim()) {
				updateKSK2120_R01List(rowData.valueIndex!, {
					...rowData,
					lotNo: '',
					lotQty: 0,
					isModified: rowData.inserted ? false : true,
				});
				return;
			}
			const originalData = {
				...rowData,
				lotNo:		oldValue || rowData.lotNo,
			};
			const workplaceCd = rowData.workplaceCd || "";
			const itemCd = rowData.childItemcd || "";
			try {
				const response	= await getLotSearchList(lotNo, workplaceCd, itemCd);
				settingCodeSearchModalProps(
					'Lot_Reel',
					lotNo,
					false,
					'lotNo',
					rowData,
					rowData.valueIndex!,
				);
			} catch (error) {
				console.error('품목 검색 중 오류:', error);
				restoreOriginalValues(rowData.valueIndex!, originalData, updateKSK2120_R01List, gridRef);
				settingCodeSearchModalProps(
					'Lot_Reel',
					lotNo,
					false,
					'lotNo',
					rowData,
					rowData.valueIndex!,
				);
			}
		},
		[
			KSK2120_R01List,
			updateKSK2120_R01List,
			settingCodeSearchModalProps,
			restoreOriginalValues,
			gridRef
		]
	);

	// 커스텀 셀 변경 핸들러
	const handleCellChange = useCallback(
		(event: any) => {
			const { data, colDef, newValue, oldValue } = event;
			if (!data || !colDef.field)	return;
			const field = colDef.field as keyof KSK2120_R01Dto;

			if (
				field === 'lotNo' &&
				newValue !== oldValue
			) {
				updateKSK2120_R01List(data.valueIndex!, {
					...data,
					[field]: newValue,
					isModified: data.inserted ? false : true,
				});

				if(field === 'lotNo') {
					handleLotNoSearch(newValue, data, oldValue);
				}

				return;
			}
			
			const originalData =
				originalKSK2120_R01List.find(
					(item: KSK2120_R01Dto) => item.valueIndex === data.valueIndex
				);
			const isModified =
				data.inserted === true
					? false
					: (originalData ? originalData[field] !== newValue : true);
			
			let updatedData = {
				...data,
				[field]: newValue,
				isModified: true
			};
			
			updateKSK2120_R01List(data.valueIndex!, updatedData);
		},
		[
			handleLotNoSearch,
			originalKSK2120_R01List,
			updateKSK2120_R01List
		]
	);

	return {
		handleCellChange,
		handleLotNoSearch
	};
}